import { contributionConstants } from "actions/types";
import type { ContributionState } from "types/state";

interface ContributionAction {
  type: string;
  data?: unknown;
}

const initialState: ContributionState = {
  perPayPeriodMax: null,
  dailyMax: null,
  recommendations: {},
  recurringContributions: [],
  contributionEstimates: {},
};

export function contribution(
  state: ContributionState = initialState,
  action: ContributionAction
): ContributionState {
  switch (action.type) {
    case contributionConstants.GET_CONTRIBUTION_RECOMMENDATIONS_SUCCESS: {
      const {
        dailyMax,
        perPayPeriodMax,
        weeklyMax,
        monthlyMax,
        everyOtherWeekMax,
        ...restOfRecs
      } = action.data as {
        dailyMax: number | null;
        perPayPeriodMax: number | null;
        weeklyMax?: number | null;
        monthlyMax?: number | null;
        everyOtherWeekMax?: number | null;
      } & object;
      return {
        ...state,
        dailyMax,
        perPayPeriodMax,
        weeklyMax,
        monthlyMax,
        everyOtherWeekMax,
        recommendations: restOfRecs,
      };
    }

    case contributionConstants.GET_RECURRING_CONTRIBUTIONS_SUCCESS: {
      return {
        ...state,
        recurringContributions: action.data as unknown[],
      };
    }
    case contributionConstants.GET_CONTRIBUTION_ESTIMATES_SUCCESS: {
      const {
        currentMonthWithPendingAmount,
        currentYearWithPendingAmount,
        currentMonthAmount,
        currentYearAmount,
      } = action.data as {
        currentMonthWithPendingAmount?: number | null;
        currentYearWithPendingAmount?: number | null;
        currentMonthAmount?: number | null;
        currentYearAmount?: number | null;
      };

      // if there is pending amount use that for the current month and year otherwise just use current month/year
      return {
        ...state,
        contributionEstimates: {
          ...(action.data as object),
          currentMonthAmount: currentMonthWithPendingAmount
            ? currentMonthWithPendingAmount
            : currentMonthAmount,
          currentYearAmount: currentYearWithPendingAmount
            ? currentYearWithPendingAmount
            : currentYearAmount,
        },
      };
    }
    default:
      return state;
  }
}
